import axios from '../request/http.js'


class Outsiders {
  /* 外来人员就餐列表 */
  static getOutsidersList(data) {
    let url = `/zzd/api/back/dining/for/outsiders/list/week`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Outsiders